import { Injector } from '@futrli/shared-services';

/**
 * Injector represents the dependency injection coding pattern, in which a class receives its dependencies
 * from external sources rather than creating them itself.
 * The injector class is used to pass to the Auth module external instances from outside, like `Authenticator`.
 */
const injector = new Injector();

export { injector };
